import { createTheme } from '@mui/material/styles';
import { darkPalette } from './palette';
import typography from './typography';
import components from './components';

const darkTheme = createTheme({
  palette: darkPalette,
  typography,
  components: {
    ...components,
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: '#32394e',
          '& .MuiTableCell-head': {
            fontWeight: 600,
            color: '#e9ecef',
            borderBottom: '2px solid #32394e',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '12px 16px',
          borderBottom: '1px solid #32394e',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 0.75rem 1.5rem rgba(0, 0, 0, 0.2)',
          backgroundColor: '#2a3042',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#2a3042',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#2a3042',
          borderRight: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2a3042',
          boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.2)',
        },
      },
    },
  },
  shape: {
    borderRadius: 4,
  },
  shadows: [
    'none',
    '0 0.125rem 0.25rem rgba(0, 0, 0, 0.2)',
    '0 0.25rem 0.5rem rgba(0, 0, 0, 0.22)',
    '0 0.5rem 1rem rgba(0, 0, 0, 0.22)',
    '0 0.75rem 1.5rem rgba(0, 0, 0, 0.25)',
    '0 1rem 2rem rgba(0, 0, 0, 0.25)',
    '0 1.5rem 3rem rgba(0, 0, 0, 0.28)',
    '0 2rem 4rem rgba(0, 0, 0, 0.28)',
    '0 2.5rem 5rem rgba(0, 0, 0, 0.3)',
    '0 3rem 6rem rgba(0, 0, 0, 0.3)',
    '0 3.5rem 7rem rgba(0, 0, 0, 0.32)',
    '0 4rem 8rem rgba(0, 0, 0, 0.32)',
    '0 4.5rem 9rem rgba(0, 0, 0, 0.35)',
    '0 5rem 10rem rgba(0, 0, 0, 0.35)',
    '0 5.5rem 11rem rgba(0, 0, 0, 0.38)',
    '0 6rem 12rem rgba(0, 0, 0, 0.38)',
    '0 6.5rem 13rem rgba(0, 0, 0, 0.4)',
    '0 7rem 14rem rgba(0, 0, 0, 0.4)',
    '0 7.5rem 15rem rgba(0, 0, 0, 0.42)',
    '0 8rem 16rem rgba(0, 0, 0, 0.42)',
    '0 8.5rem 17rem rgba(0, 0, 0, 0.45)',
    '0 9rem 18rem rgba(0, 0, 0, 0.45)',
    '0 9.5rem 19rem rgba(0, 0, 0, 0.48)',
    '0 10rem 20rem rgba(0, 0, 0, 0.48)',
    '0 10.5rem 21rem rgba(0, 0, 0, 0.5)',
  ],
});

export default darkTheme;
